import { render, staticRenderFns } from "./ESituacaoNota.vue?vue&type=template&id=431dab55"
import script from "./ESituacaoNota.vue?vue&type=script&lang=js"
export * from "./ESituacaoNota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports